export const COLLABORATION_COLORS = [
  { color: "#FFC312", theme: "light" },
  { color: "#C4E538", theme: "light" },
  { color: "#12CBC4", theme: "light" },
  { color: "#FDA7DF", theme: "light" },
  { color: "#ED4C67", theme: "dark" },
  { color: "#F79F1F", theme: "light" },
  { color: "#A3CB38", theme: "light" },
  { color: "#1289A7", theme: "light" },
  { color: "#D980FA", theme: "light" },
  { color: "#B53471", theme: "dark" },
  { color: "#EE5A24", theme: "dark" },
  { color: "#009432", theme: "dark" },
  { color: "#0652DD", theme: "dark" },
  { color: "#9980FA", theme: "light" },
  { color: "#833471", theme: "dark" },
  { color: "#EA2027", theme: "dark" },
  { color: "#006266", theme: "dark" },
  { color: "#1B1464", theme: "dark" },
  { color: "#5758BB", theme: "dark" },
  { color: "#6F1E51", theme: "dark" },
];
